import script from "./CustomSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomSlider.vue?vue&type=script&setup=true&lang=js"

import "./CustomSlider.vue?vue&type=style&index=0&id=0617f669&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0617f669"]])

export default __exports__